import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { VatData, VatResponse } from '@/api/vat.api';
import { PaginationResponse } from '@/modules/Products/interfaces';

interface VatState {
	dataVat: VatData[];
	pagination: PaginationResponse;
	getDataVat: () => VatResponse;
	setVatData: (dataVat: VatResponse) => void;
	clearDataVat: () => void;
}

const EMPTY_PAGINATION: PaginationResponse = {
	total: 0,
	page: 1,
	limit: 10,
};

export const useVatStore = create<VatState>()(
	persist(
		(set, get) => ({
			dataVat: [],
			pagination: EMPTY_PAGINATION,
			getDataVat: () => ({
				dataVat: get().dataVat,
				pagination: get().pagination,
			}),

			setVatData: (data: VatResponse) => {
				set({
					dataVat: data.dataVat,
					pagination: data.pagination,
				});
			},
			clearDataVat: () => {
				set({ dataVat: [], pagination: EMPTY_PAGINATION });
			},
		}),
		{
			name: 'vat-store',
		},
	),
);
